import ProductPageLayout, { ProductPageConfig } from "@/components/products/ProductPageLayout";
import potSoupe8oz from "@/assets/products/pot-soupe-8oz.png";
import potSoupe12oz from "@/assets/products/pot-soupe-12oz.png";
import potSoupe16oz from "@/assets/products/pot-soupe-16oz.png";
import potSoupe24oz from "@/assets/products/pot-soupe-24oz.png";
import potSoupe32oz from "@/assets/products/pot-soupe-32oz.png";

const config: ProductPageConfig = {
  name: "Pots à soupe en carton kraft",
  breadcrumbName: "Pots à soupe",
  subtitle: "Pots avec couvercle pour soupes, bouillons et plats chauds",
  features: ["Contact alimentaire", "Recyclable", "Couvercle inclus", "FSC certifié", "Résistant à la chaleur"],
  variants: [
    { ref: "GTSOPA8OZ", capacity: "350 ml (12 oz)", diameter: "Ø 96 mm", height: "75 mm", material: "Carton kraft + couvercle", packaging: "Carton de 300 (12 x 25)", palette: "30 cartons", image: potSoupe8oz },
    { ref: "GTSOPA12OZ", capacity: "480 ml (16 oz)", diameter: "Ø 96 mm", height: "100 mm", material: "Carton kraft + couvercle", packaging: "Carton de 300 (12 x 25)", palette: "30 cartons", image: potSoupe12oz },
    { ref: "GTSOPA16OZ", capacity: "750 ml (24 oz)", diameter: "Ø 115 mm", height: "100 mm", material: "Carton kraft + couvercle", packaging: "Carton de 300 (12 x 25)", palette: "20 cartons", image: potSoupe16oz },
    { ref: "GTSOPA24OZ", capacity: "1 000 ml (32 oz)", diameter: "Ø 115 mm", height: "135 mm", material: "Carton kraft + couvercle", packaging: "Carton de 200 (8 x 25)", palette: "16 cartons", image: potSoupe32oz },
  ],
};

const PotsSoupe = () => <ProductPageLayout config={config} />;
export default PotsSoupe;
